import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './dashboard.css';

class DashboardHome extends Component {
  render() {
    const { user } = this.props;
    
    // Get first name from full name
    const getFirstName = () => {
      if (!user || !user.name) return 'there';
      const names = user.name.split(' ');
      return names[0];
    };

    return (
      <div className="dashboard-fade-in">
        {/* Welcome Header */}
        <div className="dashboard-page-header">
          <h1 className="dashboard-page-title">
            Welcome back, {getFirstName()}! 👋
          </h1>
          <p className="dashboard-page-subtitle">
            Here's what's happening with your bookings
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="dashboard-card-grid">
          {/* Next Booking Card */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h2 className="dashboard-card-title">Next Booking</h2>
              <p className="dashboard-card-subtitle">Your upcoming appointment</p>
            </div>
            
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📅</div>
              <p style={{ color: '#757575', marginBottom: '24px' }}>
                No upcoming bookings
              </p>
              <Link 
                to="/dashboard/bookings" 
                className="dashboard-btn dashboard-btn-primary"
              >
                View All Bookings
              </Link>
            </div>
          </div>

          {/* Quick Actions Card */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h2 className="dashboard-card-title">Quick Actions</h2>
              <p className="dashboard-card-subtitle">Manage your account</p>
            </div>
            
            <div className="dashboard-quick-actions">
              <Link to="/dashboard/bookings" className="dashboard-quick-action">
                <div className="dashboard-quick-action-icon">📅</div>
                <h3 className="dashboard-quick-action-title">Book Again</h3>
              </Link>
              
              <Link to="/dashboard/account" className="dashboard-quick-action">
                <div className="dashboard-quick-action-icon">👤</div>
                <h3 className="dashboard-quick-action-title">My Account</h3>
              </Link>
              
              <Link to="/dashboard/account" className="dashboard-quick-action">
                <div className="dashboard-quick-action-icon">💳</div>
                <h3 className="dashboard-quick-action-title">Payments</h3>
              </Link>
              
              <a href="mailto:info@beuapp.com?subject=Help%20%26%20Support" className="dashboard-quick-action">
                <div className="dashboard-quick-action-icon">❓</div>
                <h3 className="dashboard-quick-action-title">Help</h3>
              </a>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="dashboard-card">
          <div className="dashboard-card-header">
            <h2 className="dashboard-card-title">Recent Activity</h2>
            <p className="dashboard-card-subtitle">Your latest updates</p>
          </div>
          
          <ul className="dashboard-activity-feed">
            <li className="dashboard-activity-item">
              <div className="dashboard-activity-icon">👋</div>
              <div className="dashboard-activity-content">
                <p className="dashboard-activity-text">
                  Welcome to your new Beu dashboard!
                </p>
                <p className="dashboard-activity-time">Just now</p>
              </div>
            </li>
            
            <li className="dashboard-activity-item">
              <div className="dashboard-activity-icon">✨</div>
              <div className="dashboard-activity-content">
                <p className="dashboard-activity-text">
                  Your account has been set up successfully
                </p>
                <p className="dashboard-activity-time">Today</p>
              </div>
            </li>
          </ul>
        </div>

        {/* Info Banner */}
        <div 
          className="dashboard-card" 
          style={{ 
            background: 'linear-gradient(135deg, rgba(0, 126, 160, 0.1) 0%, rgba(59, 191, 229, 0.05) 100%)',
            border: '2px solid rgba(0, 126, 160, 0.2)'
          }}
        >
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <h3 style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              color: '#007EA0',
              margin: '0 0 8px'
            }}>
              🎉 New Dashboard Experience
            </h3>
            <p style={{ 
              fontSize: '14px', 
              color: '#757575',
              margin: '0 0 16px'
            }}>
              We've redesigned your dashboard to make managing bookings easier than ever.
              More features coming soon!
            </p>
            <Link 
              to="/dashboard/bookings" 
              className="dashboard-btn dashboard-btn-primary"
              style={{ display: 'inline-flex' }}
            >
              Explore Bookings
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // User data lives at state.user.userInfo for the client dashboard — the same
  // shape DashboardAccount and DashboardSidebar read. No such reducer as the
  // one this used to destructure existed, so it read a property of undefined
  // and threw, white-screening /dashboard for every client. Optional chaining
  // too, so a not-yet-hydrated store renders the logged-out greeting instead
  // of crashing the page.
  const { user: userReducer } = state;
  return {
    user: userReducer?.userInfo || null
  };
}

export default connect(mapStateToProps)(DashboardHome);